import { render } from "./LoginBanner.vue?vue&type=template&id=84673c98&scoped=true"
import script from "./LoginBanner.vue?vue&type=script&lang=js"
export * from "./LoginBanner.vue?vue&type=script&lang=js"

import "./LoginBanner.vue?vue&type=style&index=0&id=84673c98&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84673c98"]])

export default __exports__